import EmptyState from "shared/components/data-display/tables/EmptyState";
import { COLOR_VALUES } from "shared/config/colors";
import { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import styled from "styled-components/macro";

export const InputLabel = styled.label`
    color: ${COLOR_VALUES.Gray_1};
    ${TEXT_VARIANT_STYLES.Headline_5}
`;

export const StyledEmptyState = styled(EmptyState)`
    padding-top: 12px;
    padding-bottom: 12px;
`;
